import type {
  DiscoverySupplierListParametersType,
  DiscoverySupplierListResponseType,
} from "@sellar-io/api-v2/types";
import { useInfiniteQuery } from "@tanstack/react-query";
import { useFirebaseUser } from "../../../useFirebaseUser.shared";
import { useSellarCurrentBusiness } from "../../../useSellarCurrentBusiness.shared";
import {
  apiV2AssertResponse,
  ApiV2InfiniteQueryOptions,
  apiV2Request,
  getDefaultInfiniteQueryOptionsV2,
} from "../apiV2Request";
import { ServerStateKeys } from "../ServerStateKeys";

export const useDiscoverySupplierList = <
  TData = DiscoverySupplierListResponseType,
>(
  params: DiscoverySupplierListParametersType,
  options?: ApiV2InfiniteQueryOptions<TData>,
) => {
  const { business } = useSellarCurrentBusiness();
  const { user } = useFirebaseUser();

  return useInfiniteQuery({
    queryKey: [
      user?.uid,
      business?.id,
      ServerStateKeys.DiscoverySuppliers,
      params,
    ],
    queryFn: ({ pageParam }) =>
      apiV2Request({
        user,
        business,
        method: "get",
        path: `discovery/suppliers`,
        params: {
          ...params,
          offset: pageParam,
        },
      }).then((data) => apiV2AssertResponse<TData>(data).data),
    ...getDefaultInfiniteQueryOptionsV2({
      context: { scope: "nonSupplier", user, business },
      options: { ...options, limit: params.limit },
    }),
  });
};
